export function getMessageCode(obj: unknown): string {
    const response: unknown = obj instanceof Object ? Reflect.get(obj, 'responseJSON') : null;
    const message: unknown = response instanceof Object ? Reflect.get(response, 'message') : null;
    const code: unknown = message instanceof Object ? Reflect.get(message, 'code') : null;

    return typeof code === 'string' ? code : 'n/a';
}
